import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CountdownConfig } from 'ngx-countdown';
import { interval, map, of, shareReplay, switchMap } from 'rxjs';

@Component({
  selector: 'fz-countdown',
  template: `
    <!-- <countdown
      [config]="{
        leftTime: leftTime,
        format: format
      }"
      ></countdown
    > -->
    <span>{{ this.countdown$ | async }}</span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountdownComponent implements OnInit {
  @Output()
  handleEvent = new EventEmitter();

  @Input()
  leftTime: Date | null;

  @Input()
  format: CountdownConfig['format'] = "d'd': HH'h' : mm'm' : ss's'";

  countdown$: any;

  onEvent(event: any) {
    this.handleEvent.emit(event);
  }

  ngOnInit() {
    this.countdown$ = of(this.leftTime).pipe(
      switchMap((leftTime) => {
        return leftTime ? interval(1000) : of(0);
      }),
      map((value) => {
        if (this.leftTime) {
          return this.leftTime.getTime() - Date.now();
        }
        return 0;
      }),
      map((timeDifference) => {
        // check time
        if (timeDifference <= 0) {
          this.onEvent('ended');
        }

        if (timeDifference === 0) {
          return '00d:00h:00m:00s';
        }

        const milliSecondsInASecond = 1000;
        const hoursInADay = 24;
        const minutesInAnHour = 60;
        const secondsInAMinute = 60;

        const daysToDay = Math.floor(
          timeDifference /
            (milliSecondsInASecond *
              minutesInAnHour *
              secondsInAMinute *
              hoursInADay),
        );

        const hoursToDay = Math.floor(
          (timeDifference /
            (milliSecondsInASecond * minutesInAnHour * secondsInAMinute)) %
            hoursInADay,
        );

        const minutesToDay = Math.floor(
          (timeDifference / (milliSecondsInASecond * minutesInAnHour)) %
            secondsInAMinute,
        );

        const secondsToDay =
          Math.floor(timeDifference / milliSecondsInASecond) % secondsInAMinute;

        const formatted = `${daysToDay >= 10 ? '' : '0'}${daysToDay}d : ${
          hoursToDay >= 10 ? '' : '0'
        }${hoursToDay}h : ${minutesToDay >= 10 ? '' : '0'}${minutesToDay}m : ${
          secondsToDay >= 10 ? '' : '0'
        }${secondsToDay}s`;

        return formatted;
      }),
      shareReplay(1),
    );
  }
}
